import { DISABLED_IN_MINUTES } from '@/components/Views/Admin/DataLoad';
import { CACHE_TIME, STALE_TIME } from '@/constants';
import { trpc } from '@/data-loaders';

export const useDataLoadLastRun = () => {
  return trpc.getDataLoadLastRun.useQuery(undefined, {
    retry: false,
    refetchInterval: 60 * 1000,
    refetchIntervalInBackground: true,
  });
};
